namespace TabAurous.Common {
    export interface SalesSummaryReportForm {
        Categories: Reports.CategoryWiseEditor;
        Weekly: Reports.WeeklyReportEditor;
        Quarterly: Reports.QuarterlyReportEditor;
        Monthly: Reports.MonthlyReportEditor;
    }

    export class SalesSummaryReportForm extends Serenity.PrefixedContext {
        static formKey = 'Common.SalesSummaryReportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SalesSummaryReportForm.init)  {
                SalesSummaryReportForm.init = true;

                var s = Serenity;
                var w0 = Reports.CategoryWiseEditor;
                var w1 = Reports.WeeklyReportEditor;
                var w2 = Reports.QuarterlyReportEditor;
                var w3 = Reports.MonthlyReportEditor;

                Q.initFormType(SalesSummaryReportForm, [
                    'Categories', w0,
                    'Weekly', w1,
                    'Quarterly', w2,
                    'Monthly', w3
                ]);
            }
        }
    }
}
